import React from 'react'
import classNames from 'classnames'
import './Button.less'
import { Button as AntButton } from 'antd'

const Button = React.forwardRef(({ align, className, v2 = true, ...props }, ref) => {
  // keep by default v2 style enabled. We have to do this because DropDown menu
  // use btn in form it use v1 style and else where it use v2 style.
  // so even we are in feature flag we need both style on UX v2
  const buttonClass = classNames(
    'pan-button',
    {
      'align-right float-right': align && align === 'right',
      'align-left float-left': align && align === 'left',
    },
    !v2 ? 'btn-v1-border-radius' : null,
    className || '',
  )

  return (
    <AntButton className={buttonClass} {...props} ref={ref}>
      {props.children}
    </AntButton>
  )
})
Button.displayName = 'Button'

Button.AntButton = AntButton
export default Button
